import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as ControllerStyles from "../styles/controller";

function MainMenu() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [menu, setMenu] = useState([
        {
            title: "Categories",
            nav: "categories"
        },
        {
            title: "Products",
            nav: "products"
        },
        {
            title: "Colours",
            nav: "colours"
        },
        {
            title: "Postage & Shipping",
            nav: "post_ship"
        },
        {
            title: "Orders",
            nav: "orders"
        },
        {
            title: "Sales",
            nav: "sales"
        },
        {
            title: "Policies",
            nav: "policies"
        },
        {
            title: "Links",
            nav: "links"
        },
        {
            title: "Settings",
            nav: "settings"
        }
    ]);

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("3D Printing Service"));
        dispatch(GS_navSettingsActions.UpdateSelected("Features"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("3D Printing Service"));
    }, []);

    function itemNavigate(nav) {
        navigate(`./${nav}`);
    }

    return (
        <div style={ControllerStyles.body}>
            {menu.map((item, index) => {
                return (
                    <div key={index}>
                        <Card style={ControllerStyles.cardStyle} onClick={itemNavigate.bind(this, item.nav)}>
                            <Card.Body>
                                <Row>
                                    <Col>{item.title}</Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        <br />
                    </div>
                );
            })}
        </div>
    );
}

export default MainMenu;
